import React, { useState, useEffect } from 'react'

import Preview from './Preview'
import { root } from 'src/utils/mountReactApp'

const supportedPaymentOptions = ['paymentRequest', 'credit_card']

const App = ({ donation, honoreeName }) => {
  const [ cardSent, setCardSent ] = useState(false)

  const isSupported = supportedPaymentOptions.includes(donation?.paymentOption)

  useEffect(() => {
    const handleCardSent = () => setCardSent(true)
    root.addEventListener('cardSent', handleCardSent)
    return () => root.removeEventListener('cardSent', handleCardSent)
  }, [])

  useEffect(() => {
    if (isSupported)
      root.dispatchEvent(new CustomEvent('donationSet', { detail: donation }))
  }, [ donation, isSupported ])

  if (!isSupported) return null

  return (
    <div className="bg-light px-3 py-4 px-sm-4 py-sm-5 rounded-4 thankyou-replacement">
      <div className="mx-auto" style={{ maxWidth: '30rem' }}>
        <h2 tabIndex={-1} className="h5 mb-3 focus-target text-center">
          Thank you for your donation!<br/> Send your condolences to the family.
        </h2>
        <div className="mb-3">
          <Preview donation={donation} honoreeName={honoreeName} />
        </div>
        {
          cardSent
        ? <div className="alert alert-success">Your card is on its way!</div>
        : <div>
            <p>
              Let the family know about your gift with a printed sympathy card.
              We’ll mail it tomorrow, and we’ll use the same payment method from
              your donations — no need to re-enter your payment details.
            </p>
            <p className="mb-0">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#sympathyCardModal"
              >
                Add a Card
              </button>
            </p>
          </div>
        }
      </div>
    </div>
  )
}

export default App
